(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      /* The product page's tab bar holds the header while it is pinned
         under it (assets/pdp-section-nav.js). Hiding here would leave the
         tabs floating with nothing above them, and would close an open
         menu or search on every scroll. */
      if (this.header.classList.contains('pdp-header-hold')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      /* The header's search is the drawer now, not Dawn's modal, so there
         may be no modal to close -- without the check this threw on
         every hide. */
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__tv) return; root.__tv = true;
    var d = root.dataset, q = function (s) { return root.querySelector(s); };
    var range = q('[data-hours]'), out = q('[data-hours-out]'), pay = q('[data-pay]');
    var cur = d.currency || '', loss = (+d.loss || 0) / 100, days = +d.days || 230,
        hpy = +d.hpy || 1840, hpd = +d.hpd || 8, price = +d.price || 0, mode = 'yearly';
    var fmt = function (v) { return Math.round(v).toLocaleString(); };
    function calc() {
      var h = +range.value; out.textContent = h % 1 ? h.toFixed(1) : h;
      var p = parseFloat(pay.value) || 0, hourly = mode === 'yearly' ? p / hpy : p;
      var lost = h * loss * days, cost = lost * hourly, daily = cost / days;
      q('[data-r1]').textContent = fmt(lost);
      q('[data-r2]').textContent = fmt(lost / hpd);
      q('[data-r3]').textContent = cur + fmt(cost);
      q('[data-payback]').textContent = daily > 0 ? (Math.ceil(price / daily) > 999 ? '999+' : Math.max(1, Math.ceil(price / daily))) : '–';
    }
    root.querySelectorAll('[data-mode]').forEach(function (m) {
      m.addEventListener('change', function () {
        if (!m.checked || m.value === mode) return;
        var p = parseFloat(pay.value) || 0; mode = m.value;
        pay.value = mode === 'hourly' ? Math.round(p / hpy) : Math.round(p * hpy / 1000) * 1000;
        calc();
      });
    });
    range.addEventListener('input', calc); pay.addEventListener('input', calc); calc();
  }
  function run() { document.querySelectorAll('[data-tv-calc]').forEach(init); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-offer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', function (e) {
  var r = e.target.closest && e.target.closest('[data-tv-offer] input[name="id"]');
  if (!r) return;
  var p = r.closest('.tv-offer').querySelector('[data-tv-price]');
  if (p && r.dataset.price) p.textContent = r.dataset.price;
});

  } catch(e) { console.error(e); }
})();
})();
